import { useState } from "react";
import styles from "./PanierAuth.module.css";
import TrashIcon from "assets/icons/trash";
import Button from "./Button";
import { Link } from "react-router-dom";

const PanierAuth = () => {
  const [cart, setCart] = useState([{
  }]);
  return (
    <div className={styles.PanierAuth}>

      <div className={styles.AuthAlert}>
        <div className={styles.Title}>Veuillez vous identifier pour pouvoir finaliser votre commande</div>
        <Link to="/login">
          <Button>S’identifier</Button>
        </Link>
        <p className={styles.Description}>Vous ne possédez pas encore de compte ? <Link to="/inscription">Inscrivez-vous ici</Link></p>
      </div>
    </div>
  );
}

export default PanierAuth;
